import { useState, useEffect, useRef } from "react";
import GalleryItem from "../../components/galleryItem";
import Player from "../../player/player-static";
import { useMediaQuery } from "../../utils/useMediaQuery";


const Gallery = ({ data }) => {
  const [error, setError] = useState("");
  const [playerOpen, setPlayerOpen] = useState(false);
  const [itemData, setItemData] = useState({});

  const gridSize = useMediaQuery({
    default:data.settings.itemsPerRow.s,
    md:data.settings.itemsPerRow.md,
    lg:data.settings.itemsPerRow.lg,
    xl:data.settings.itemsPerRow.xl,
    xxl:data.settings.itemsPerRow.xxl,
  });

  const openPlayer = (item) => {
    setItemData(item);
    setPlayerOpen(true);
  };

  const closePlayer = () => {
    setPlayerOpen(false);
  };

 if (error) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <div className="bg-black/90 p-5 rounded-md">
          <span className="text-white">{error}</span>
        </div>
      </div>
    );
  } else {
    return (
      <div id={`widget-${data.id}`} className="w-full relative select-none">
        <div className="vf-grid grid h-full w-full grid-cols-1" style={{
          gridTemplateColumns : `repeat(${gridSize}, minmax(0, 1fr))`,
          gridGap : `${data.settings.gap}px`
        }}
        >
          {data.content.map((item) => (
            <GalleryItem
              key={item.id}
              item={item}
              settings = {data.settings}
              onClick={openPlayer}
            ></GalleryItem>
          ))}
        </div>
        {playerOpen && <Player onClose={closePlayer} item={itemData} widget={data.id} settings={data.settings} />}
      </div>
    );
  }
};

export default Gallery;
